import { LogOut, User as UserIcon } from 'lucide-react';
import type * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/stores/useAuthStore';

interface HeaderProps {
  title: string;
  actions?: React.ReactNode;
}

export function Header({ title, actions }: HeaderProps) {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      // Navigate anyway since local state is cleared
      navigate('/login');
    }
  };

  // Display user name if available
  const displayName = user?.name || user?.firstName || 'Admin';

  return (
    <div className="bg-white border-b border-[#e5e5e5] px-[40px] py-[24px] flex items-center justify-between">
      <h2 className="text-[#181818] text-[28px] font-semibold">{title}</h2>
      <div className="flex items-center gap-[16px]">
        {actions && <div>{actions}</div>}
        <div className="flex items-center gap-[12px] pl-[16px] border-l border-[#e5e5e5]">
          <div className="flex items-center gap-[8px] px-[12px]">
            <div className="w-[32px] h-[32px] bg-[#f5f5f5] rounded-full flex items-center justify-center">
              <UserIcon size={16} className="text-[#646464]" />
            </div>
            <span className="text-[14px] font-semibold text-[#646464]">{displayName}</span>
          </div>
          <Button
            variant="ghost"
            onClick={handleLogout}
            disabled={isLoggingOut}
            className="h-[36px] px-[16px] rounded-[8px] hover:bg-[#f5f5f5] text-[#646464] hover:text-[#181818]"
          >
            <LogOut size={16} className="mr-[6px]" />
            {isLoggingOut ? 'Logging out...' : 'Logout'}
          </Button>
        </div>
      </div>
    </div>
  );
}
